import { createFileRoute } from '@tanstack/react-router'
import { SiteInspectionsPage } from '@/features/site-inspections'

export const Route = createFileRoute('/site-inspections')({
  component: SiteInspectionsPage,
})
